var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttonConfig",class:_vm.positionClass},[_vm._t("default",function(){return [_c('Button',{attrs:{"bezel":""}},[_vm._v("Cancel")]),_c('Button',{attrs:{"bezel":"","theme":"primary"}},[_vm._v("Submit")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }